import React from 'react';
import { Camera, Clapperboard, Layers, Radio, Scissors, Video } from 'lucide-react';
import { WORK_TYPES } from '../utils/workTypes';

export const STATUS_LABELS = {
  assigned: 'Assigned',
  in_progress: 'In progress',
  completed: 'Completed'
};

const TYPE_ICONS = { photo: Camera, video: Video, editing: Scissors, reels: Clapperboard, live: Radio, other: Layers };
export const TYPE_META = Object.fromEntries(
  Object.entries(WORK_TYPES).map(([type, meta]) => [type, { ...meta, icon: TYPE_ICONS[type] }])
);

const time = (date) => new Date(date || 0).getTime() || 0;

export const taskTitle = (task) =>
  task.event_title && task.event_title !== 'No_event' ? task.event_title : 'Standalone task';

export const isOverdue = (task) =>
  task.status !== 'completed' && task.due_date && time(task.due_date) < Date.now();

export function StatusPill({ status }) {
  return (
    <span className={`event-status status-${status}`}>
      <i />
      {STATUS_LABELS[status] || status?.replaceAll('_', ' ') || 'Not set'}
    </span>
  );
}

export function TypeTile({ type, size = 48 }) {
  const knownType = Object.hasOwn(TYPE_META, type);
  const meta = knownType ? TYPE_META[type] : TYPE_META.other;
  const Icon = meta.icon;
  return (
    <span
      className={`task-type type-${knownType ? type : 'other'}`}
      style={{ width: size, height: size }}
    >
      <Icon size={Math.round(size * 0.44)} strokeWidth={1.8} />
    </span>
  );
}
